import React from 'react';
import VaccinationsTable from './Components/VaccinationsTable';

const VaccinationsPage = () => {
  return (
    <div className="w-full h-full">
      <div className="pb-1">
        <VaccinationsTable />
      </div>
    </div>
  );
};

export default VaccinationsPage;
